if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        const watchId = this.dataset.watch;
        const target = watchId && document.getElementById(watchId);

        if (!target || !('IntersectionObserver' in window)) {
          this.classList.add('sticky-atc--visible');
        } else {
          this.observer = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              this.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
            },
            { threshold: 0 }
          );
          this.observer.observe(target);
        }

        if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
          this.unsubscribe = window.subscribe(window.PUB_SUB_EVENTS.variantChange, (event) => {
            if (event?.data?.sectionId !== this.dataset.sectionId) return;
            this.updateFromVariant(event.data.variant);
          });
        }
      }

      updateFromVariant(variant) {
        if (!variant) return;

        const priceEl = this.querySelector('[data-sticky-atc-price]');
        const variantEl = this.querySelector('[data-sticky-atc-variant]');
        const mediaEl = this.querySelector('.sticky-atc__media img');
        const button = this.querySelector('.sticky-atc__button');

        if (priceEl && typeof variant.price === 'number') {
          const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
          try {
            priceEl.textContent = new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(
              variant.price / 100
            );
          } catch (error) {
            priceEl.textContent = `$${(variant.price / 100).toFixed(2)}`;
          }
        }

        if (variantEl) {
          if (variant.title && variant.title !== 'Default Title') {
            variantEl.textContent = variant.title;
            variantEl.hidden = false;
          } else {
            variantEl.hidden = true;
          }
        }

        if (mediaEl && variant.featured_media?.preview_image?.src) {
          mediaEl.src = variant.featured_media.preview_image.src;
        }

        if (button) {
          const soldOut = !variant.available;
          button.disabled = soldOut;
          button.querySelector('span')
            ? (button.querySelector('span').textContent = soldOut
                ? window.variantStrings?.soldOut || 'Sold out'
                : window.variantStrings?.addToCart || 'Add to cart')
            : (button.textContent = soldOut
                ? window.variantStrings?.soldOut || 'Sold out'
                : window.variantStrings?.addToCart || 'Add to cart');
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.unsubscribe?.();
      }
    }
  );
}
